export const projects = [
	{ id: 1, project: 'Alegria Dos Rios', acronym: 'ADR', sector: 'South' },
	{
		id: 2,
		project: 'Golden Empire Tower / 1322',
		acronym: 'GET',
		sector: 'Vertical',
	},
	{
		id: 3,
		project: 'Grand Riviera Suites',
		acronym: 'GRS',
		sector: 'Vertical',
	},
	{ id: 4, project: 'Grand View Tower', acronym: 'GVT', sector: 'Vertical' },
	{ id: 5, project: 'Heritage Homes Indang', acronym: 'HHI', sector: 'South' },
	{ id: 6, project: 'Heritage Homes Marilao', acronym: 'HHM', sector: 'North' },
	{
		id: 7,
		project: 'Heritage Homes Trece Martires',
		acronym: 'HHTM',
		sector: 'South',
	},
	{ id: 8, project: 'Heritage Spring Homes', acronym: 'HSH', sector: 'South' },
	{
		id: 9,
		project: 'Heritage Villas Angeles',
		acronym: 'HVA',
		sector: 'North',
	},
	{
		id: 10,
		project: 'Heritage Villas San Jose',
		acronym: 'HVSJ',
		sector: 'North',
	},
	{ id: 11, project: 'Metro Villa Center', acronym: 'MVC', sector: 'North' },
	{ id: 12, project: 'Metrogate Angeles', acronym: 'MGA', sector: 'North' },
	{
		id: 13,
		project: 'Metrogate Centara Tagaytay',
		acronym: 'MGCT',
		sector: 'South',
	},
	{ id: 14, project: 'Metrogate Complex', acronym: 'MGC', sector: 'North' },
	{ id: 15, project: 'Metrogate Dasmarinas', acronym: 'MGD', sector: 'South' },
	{
		id: 16,
		project: 'Metrogate Dasmarinas Estates',
		acronym: 'MGDE',
		sector: 'South',
	},
	{ id: 17, project: 'Metrogate Indang', acronym: 'MGI', sector: 'South' },
	{
		id: 18,
		project: 'Metrogate Meycauayan 2',
		acronym: 'MMII',
		sector: 'North',
	},
	{
		id: 19,
		project: 'Metrogate North Villas',
		acronym: 'MGNV',
		sector: 'North',
	},
	{ id: 20, project: 'Metrogate Primavera', acronym: 'MGP', sector: 'South' },
	{ id: 21, project: 'Metrogate San Jose', acronym: 'MGSJ', sector: 'North' },
	{
		id: 22,
		project: 'Metrogate Silang Estates',
		acronym: 'MGSE',
		sector: 'South',
	},
	{
		id: 23,
		project: 'Metrogate Spring Meadows',
		acronym: 'MGSM',
		sector: 'North',
	},
	{ id: 24, project: 'Metrogate Sta. Rosa', acronym: 'MGSR', sector: 'South' },
	{
		id: 25,
		project: 'Metrogate Tagayay Estates',
		acronym: 'MGTE',
		sector: 'South',
	},
	{
		id: 26,
		project: 'Metrogate Tagaytay Manors',
		acronym: 'MTM',
		sector: 'South',
	},
	{
		id: 27,
		project: 'Metrogate Trece Martires',
		acronym: 'MGTM',
		sector: 'South',
	},
	{ id: 28, project: 'Metrogate Villas', acronym: 'MGV', sector: 'North' },
	{
		id: 29,
		project: 'Moldex Residences Baguio',
		acronym: 'MRB',
		sector: 'Vertical',
	},
	{
		id: 30,
		project: 'Moldex Residences Silang',
		acronym: 'MRS',
		sector: 'Vertical',
	},
	{
		id: 31,
		project: 'Moldex Residences Valenzuela',
		acronym: 'MRV',
		sector: 'Vertical',
	},
	{
		id: 32,
		project: 'Tagaytay Southridge Estates',
		acronym: 'TSE',
		sector: 'South',
	},
	{ id: 33, project: 'The Grand Tower', acronym: 'TGT', sector: 'Vertical' },
	{ id: 34, project: 'Villa Caceres Estates', acronym: 'VCE', sector: 'South' },
];
